<template>
  <tr
    v-tooltip="{ content: sale.title, delay: { show: 1500, hide: 100 }, placement: 'bottom' }"
    :class="['sale-row', { alert: isStaff && sale.alertPrice }]"
    @click.stop.prevent="openSale(sale.url)"
  >
    <td>{{ sale.displayDate }}</td>
    <td right>
      <b>{{ $filters.currency(sale.price, { full: true }) }}</b>
    </td>
    <td right>
      {{ sale.listingType }}
    </td>
    <td right>
      {{ sale.platform }}
    </td>

    <td class="action">
      <icon-button
        v-if="sale.notes"
        icon="info"
        size="16"
        :tooltip="sale.notes"
      />

      <icon-button
        v-if="isStaff && isLadderCard"
        icon="delete_outline"
        size="16"
        tooltip="Delete sale"
        @click.stop.prevent="$emit('deleteSale', purgatory ? sale.itemId : sale.id)"
      />
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

const THREE_MONTHS_AGO = moment().subtract(3, 'months').startOf('day').toDate();

export default {
  props: {
    sale: Object,
    purgatory: Boolean,
    viewType: Boolean,
    isLadderCard: Boolean,
  },

  computed: {
    ...mapGetters({
      isStaff: 'isStaff',
    }),

    isEbaySale() {
      return this.sale?.platform === 'eBay';
    },
  },

  methods: {
    openSale() {
      if (this.sale.itemId && this.sale.platform === 'eBay' && this.sale.date < THREE_MONTHS_AGO) {
        this.windowOpen(`/sales-history?saleId=${this.sale.itemId.includes('ebay') ? '' : 'ebay-'}${this.sale.itemId}`);
      } else if (this.sale.url) {
        this.windowOpen(this.sale.url);
      }
    },

    windowOpen(url) {
      if (url) {
        let saleUrl = url;

        if (this.isEbaySale && !url.includes('sales-history')) {
          saleUrl += '?nordt=true&rt=nc&orig_cvip=true';
        }

        window.open(saleUrl, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sale-row {
  &:hover {
    background-color: var(--theme-highlight);
    cursor: pointer;
  }

  &.alert {
    color: $color-red-1;
  }
}

.action > *:not(:last-child) {
  margin-right: $gp * .5;
}
</style>

